import { render, staticRenderFns } from "./AssignGroups.vue?vue&type=template&id=c55fda32&scoped=true"
import script from "./AssignGroups.vue?vue&type=script&lang=js"
export * from "./AssignGroups.vue?vue&type=script&lang=js"
import style0 from "./AssignGroups.vue?vue&type=style&index=0&id=c55fda32&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55fda32",
  null
  
)

export default component.exports